// extracted by mini-css-extract-plugin
export default {"gradient":"feedbacks_gradient__dLFKQ","feedbacks":"feedbacks_feedbacks__-ff+h","feedbacks_list":"feedbacks_feedbacks_list__vmXyA","second_row":"feedbacks_second_row__sqoxA"};